<template>
    <MultiSelectBaseDropdown v-bind="$props" v-on="$listeners"
                             @selectedItem="updateCounter"
                             @unselectedItem="updateCounter"
                             @closeMenu="updateCounter"
                             @selectAllClicked="updateCounter"
    >
        <template #dropdownField="slotProps">
            <slot name="dropdownField" :dropdownFieldTitle="slotProps.dropdownFieldTitle"/>
        </template>
        <template slot="postOption" v-if="postIconKey && slotData.option[postIconKey]" slot-scope="slotData">
            <span class="post-option">
                <Tooltip :text="getTooltipValue(slotData.option)"
                         :key="`${changeCounter}Tooltip`"
                         :preventOverflow="false"
                         :id="`postIcon${getPostIconValue(slotData.option)}`"
                >
                    <IconBase :iconName="getPostIconValue(slotData.option) + 'Icon'"
                              v-if="getPostIconValue(slotData.option)"
                              :key="`${changeCounter}Icon`"
                              width="10"
                              height="12"/>
                    <span v-else></span>
                </Tooltip>
            </span>
        </template>
        <template slot="preOption" v-if="preIconKey && slotData.option[preIconKey]" slot-scope="slotData">
            <img :src="getPreIconValue(slotData.option)" :key="`${changeCounter}Image`"
                 class="pre-option-image"/>
        </template>
    </MultiSelectBaseDropdown>
</template>

<script>
import MultiSelectBaseDropdown from 'components/dropdowns/MultiSelectBaseDropdown.vue';
import IconBase from 'components/IconBase.vue';
import Tooltip from 'components/Tooltip/Tooltip.vue';

export default {
    name: 'MultiSelectWithIconsBaseDropdown',
    components: {
        Tooltip,
        MultiSelectBaseDropdown,
        IconBase
    },
    props: {
        ...MultiSelectBaseDropdown.props,
        preIconKey: String,
        postIconKey: String,
        isPostIconFunction: Boolean,
        isPreIconFunction: Boolean,
        descriptionKey: String
    },
    data: () => ({
        changeCounter: 0
    }),
    methods: {
        updateCounter() {
            this.changeCounter += this.changeCounter;
        },
        getPostIconValue(option) {
            return this.isPostIconFunction ? option[this.postIconKey]() : option[this.postIconKey];
        },
        getTooltipValue(option) {
            const key = `${this.postIconKey}Tooltip`;
            if (!option[key]) {
                return '';
            }
            return this.isPostIconFunction ? option[key]() : option[key];
        },
        getPreIconValue(option) {
            return this.isPreIconFunction ? option[this.preIconKey]() : option[this.preIconKey];
        }
    }
};
</script>
<style>
.post-option {
    position: absolute;
    top: 12px;
    right: 0px;
}
.pre-option-image {
    width: 20px;
    height: 20px;
    border-radius: 4px;
    vertical-align: middle;
    margin-left: 16px;
    margin-right: 10px;
}
</style>
